import {useSelector} from 'react-redux';

import {orderSelectors} from '../index';


/**
 * Checks if the order summary has been loaded (exists in store)
 *
 * @param orderId {string} Order id to check loaded summary state
 * @return {boolean} True if order summary loaded; false otherwise
 */
function useIsOrderSummaryLoaded(orderId) {

    return useSelector(state => orderSelectors.isOrderSummaryLoaded(state, orderId));
}


export default useIsOrderSummaryLoaded;
